import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import axios from '../lib/axios';
import ReactRailsUJS from '../lib/react-rails';

export default class Modal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    async: PropTypes.bool,
    asyncUrl: PropTypes.string,
    asyncMethod: PropTypes.string,
    modalContentSelector: PropTypes.string,
    modalContentDeleteOriginal: PropTypes.bool,
    modalWrapperClassName: PropTypes.string,
    modalContainerId: PropTypes.string,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    onClose: () => {},
    async: false,
    asyncUrl: '',
    asyncMethod: 'get',
    modalContentSelector: null,
    modalContentDeleteOriginal: true,
    modalWrapperClassName: null,
    modalContainerId: null,
    visible: true,
  }

  constructor(props) {
    super(props);

    this.state = {
      content: null,
    };

    this.modalRef = React.createRef();
  }

  fetchAsyncContent() {
    axios
      .request({
        url: this.props.asyncUrl,
        method: this.props.asyncMethod,
      })
      .then((response) => {
        if (response.headers['content-type'].indexOf('text/javascript') !== -1) {
          eval(response.data);
        } else {
          this.setState({ content: response.data });
        }
      });
  }

  // This only supports 1 script tag at the moment. Consider supporting many.
  // Ref: https://stackoverflow.com/questions/35614809/react-script-tag-not-working-when-inserted-using-dangerouslysetinnerhtml
  executeScriptTags(html) {
    $(() => {
      $(html).filter('script').each((i, e) => eval(e.innerText));
      $(html).find('script').each((i, e) => eval(e.innerText));
    });
  }

  componentDidUpdate(prevProps) {
    const {
      async, modalContainerId, visible, modalContentSelector, modalContentDeleteOriginal,
    } = this.props;

    if (visible) {
      window.document.body.classList.add('u-overflow-hidden'); // prevent body from scrolling when a modal is opened
      if (prevProps.visible !== visible && !async) {
        this.setState({ content: modalContentSelector ? document.querySelector(modalContentSelector).innerHTML : null });
      } else if ((prevProps.visible !== visible && async) || (async && this.state.content === null)) {
        this.fetchAsyncContent();
      }

      if (modalContentSelector && modalContentDeleteOriginal) {
        // Clear the modal content selector's contents so that we don't duplicate the code in the DOM.
        ReactRailsUJS.unmountComponents(modalContentSelector);
        document.querySelector(modalContentSelector).innerHTML = '';
      }

      ReactRailsUJS.mountComponents(`#${modalContainerId !== null ? modalContainerId : 'modal-container'}`);
      window.Union.setupWizard(`#${modalContainerId !== null ? modalContainerId : 'modal-container'}`);
      window.Union.initializeTippy();
      this.executeScriptTags(this.state.content);
    } else {
      window.document.body.classList.remove('u-overflow-hidden');
    }
  }

  handleClick = (e) => {
    const modalElement = this.modalRef.current;
    const modalDismiss = modalElement.querySelector('.Modal-dismiss');

    if ((!modalElement.contains(e.target) && modalElement !== e.target) ||
      (modalDismiss !== null && modalDismiss.contains(e.target)) ||
      (modalDismiss !== null && modalDismiss === e.target)) {
      const { modalContainerId, modalContentSelector, modalContentDeleteOriginal } = this.props;
      if (modalContentSelector && modalContentDeleteOriginal) {
        // Restore the modal content selector's contents to be what we were just showing in the modal.
        ReactRailsUJS.unmountComponents(`#${modalContainerId !== null ? modalContainerId : 'modal-container'}`);
        document.querySelector(modalContentSelector).innerHTML = document.querySelector(
          `#${modalContainerId !== null ? modalContainerId : 'modal-container'}`
        ).innerHTML;
        ReactRailsUJS.mountComponents(modalContentSelector);
      }
      this.props.onClose(e);
    }
  }

  render() {
    const {
      onClose, async, asyncUrl, asyncMethod, modalContentSelector, modalContentDeleteOriginal,
      modalWrapperClassName, visible, modalContainerId, ...otherProps
    } = this.props;

    return visible ? ReactDOM.createPortal(
      <div id="modal-overlay-wrapper">
        <div className="u-overlay u-z-200" />
        <div className="u-fixed u-inset-y-0 u-z-250 u-flex u-w-full u-h-full u-justify-center u-overflow-y-auto u-cursor-pointer" onClick={this.handleClick}>
          <div className={`Modal-wrapper ${modalWrapperClassName} u-cursor-auto`}>
            <div className="Modal u-m-4 u-shadow u-bg-white u-rounded u-border-grey-darkest u-flex-1 u-pointer-events-auto"
                 {...otherProps}
              ref={this.modalRef}
            >
              {
                (async || modalContentSelector) && (
                  <div
                    className="ModalContainer u-relative reveal-modal open"
                    id={`${modalContainerId !== null ? modalContainerId : 'modal-container'}`}
                    dangerouslySetInnerHTML={{ __html: this.state.content }}
                  />
                )
              }
              { !async && this.props.children }
            </div>
          </div>
        </div>
      </div>,
      document.body
    ) : null;
  }
}
